import { z } from 'zod';
export const partnerRequestPreferenceSchema = z.enum(['All', 'Validated', 'ValidatedOwnerOnly']);
export const PartnerRequestPreference = partnerRequestPreferenceSchema.enum;
